import { ObjectResponseType } from '@pray/shared/utils/api/types/response';

import type { CreateEpisodeResponse } from './types';

export type CreateEpisodeServiceParams = {
  artistId: string;
  courseId: string;
};

/**
 * Creates a new episode in a course
 * @param params - The parameters for creating a new episode
 * @param params.artistId - The ID of the artist to add the episode to
 * @param params.courseId - The ID of the course to add the episode to
 * @returns A promise that resolves to the created episode data
 */
export async function createEpisode({
  artistId,
  courseId,
}: CreateEpisodeServiceParams): Promise<CreateEpisodeResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!courseId) throw new Error('Course ID is required');

  await new Promise((resolve) => setTimeout(resolve, 800));

  const response: CreateEpisodeResponse = {
    /* eslint-disable camelcase */
    responded_at: new Date().toISOString(),
    object: ObjectResponseType.OBJECT,
    data: {
      id: `ep_${crypto.randomUUID()}`,
      course_id: courseId,
      title: 'New Episode Title',
      transcript: '<h1>New Episode Title</h1><p>New Episode Transcript</p>',
    },
    /* eslint-enable camelcase */
  };

  return response;

  // Uncomment when server implementation is ready
  // const url = `/studio/artists/${artistId}/courses/${courseId}/episodes`;
  // const response = await api.executePostRequest<CreateEpisodeResponse>(url, {
  //   title,
  //   transcript
  // });
  // return response.data;
}
